import { render } from "./ImportAddress.vue?vue&type=template&id=9ca7dd4e&scoped=true"
import script from "./ImportAddress.vue?vue&type=script&lang=js"
export * from "./ImportAddress.vue?vue&type=script&lang=js"

import "./ImportAddress.vue?vue&type=style&index=0&id=9ca7dd4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca7dd4e"]])

export default __exports__